/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useLayout} from '../core'

const Footer: FC = () => {
  const {classes} = useLayout()
  return (
    <div className='footer py-4 d-flex flex-lg-column' id='kt_footer'>
      {/* begin::Container */}
      <div
        className={`${classes.footerContainer} d-flex flex-column flex-md-row align-items-center justify-content-center`}
      >
        {/* begin::Copyright */}
        <div className='text-dark order-2 order-md-1'>
          <span className='text-muted fw-bold me-2'>Copyright &copy; 2019
            <a href='https://www.pilotgarage.com/' target='_blank' className='text-gray-800 text-hover-primary'>
          &nbsp; PİLOT GARAGE	&nbsp;
          </a>
          Tüm Hakları Saklıdır.
          </span>
        </div>
        {/* end::Copyright */}
        
      </div>
      {/* end::Container */}
    </div>
  )
}

export {Footer}
